import Blockly from 'blockly'
import 'blockly/python'

let blockJson = {
  type: 'machine_ifzero_lcd_control',
  message0: '%{BKY_CUSTOM_MACHINE_IFZERO_LCD_CONTROL}',
  args0: [
    {
      type: 'field_image',
      src: 'https://i.ibb.co/kByzBzq/ifkit.jpg',
      width: 30,
      height: 30,
      alt: '*'
    },
    {
      type: 'field_dropdown',
      name: 'COMMAND',
      options: [
        ['%{BKY_CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_CLEAR}', 'clear'],
        ['%{BKY_CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_HOME}', 'home'],
        [
          '%{BKY_CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_SHOW_UNDERLINE}',
          'show_underline'
        ],
        [
          '%{BKY_CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_HIDE_UNDERLINE}',
          'hide_underline'
        ],
        ['%{BKY_CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_SHOW_BLINK}', 'show_blink'],
        ['%{BKY_CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_HIDE_BLINK}', 'hide_blink'],
        ['%{BKY_CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_MOVE_LEFT}', 'move_left'],
        ['%{BKY_CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_MOVE_RIGHT}', 'move_right']
      ]
    }
  ],
  inputsInline: true,
  previousStatement: null,
  nextStatement: null,
  style: 'display_blocks',
  tooltip: '%{BKY_CUSTOM_MACHINE_IFZERO_LCD_CONTROL_TOOLTIP}',
  helpUrl: ''
}

Blockly.Blocks['machine_ifzero_lcd_control'] = {
  init: function () {
    this.jsonInit(blockJson)
  }
}

Blockly.Python['machine_ifzero_lcd_control'] = function (block) {
  if (!block.disabled)
    Blockly.Python.definitions_.import_ifzero = 'import ifzero'
  let command = block.getFieldValue('COMMAND')
  let code = `ifzero.lcdControl('${command}')\n`
  return code
}
